<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.15548 7.77154C2.73855 7.24994 3.22239 6.49627 3.87032 6.65825L7.29805 7.51568L7.29805 1.50005L8.84981 1.50005L8.84981 7.51568L12.2775 6.65825C12.9255 6.49626 13.4095 7.24994 12.9924 7.77154L8.61934 13.2383C8.34007 13.5874 7.80895 13.5872 7.5295 13.2383L3.15548 7.77154Z" fill="#000928"/>
    <rect y="15.5" width="16" height="2" fill="#000928"/>
</svg>
